import { Page } from '@/core/architecture'

import { ConsoleTicketReceivesTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleTicketReceives Page
 * Implemented as a practical sample.
 */
export const ConsoleTicketReceives: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleTicketReceivesTemplate state={state} {...actions} />
}
